import { APP_CONSTANTS } from 'src/consumer/constants'

import * as React from 'react'
import { CenteredLogo, SplashScreenBackground } from './LoaderStyles'

export const LoadingSpinner = ({ bgColor, dark }) => {
  // Always use pure white background to match the first loader exactly
  const backgroundColor = '#fff'

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: backgroundColor,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999, // Same as initial loader for seamless transition
        opacity: 1,
      }}
    >
      <div style={{ 
        textAlign: 'center', 
        width: '100%', 
        maxWidth: '300px', 
        padding: '20px',
      }}>
        {/* AUMHUM Logo */}
        <img 
          src={APP_CONSTANTS.APP_LOGO_LINK} 
          alt="" 
          aria-hidden="true"
          style={{
            height: '60px',
            width: 'auto',
            margin: '0 auto 30px',
            display: 'block',
            opacity: 1,
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          }}
          onError={(e) => {
            e.target.src = '/logo_brand.png'
          }}
        />
        {/* Progress Bar */}
        <div 
          aria-hidden="true" 
          style={{
            width: '100%',
            height: '4px',
            background: '#f3f3f3',
            borderRadius: '2px',
            overflow: 'hidden',
            marginTop: '20px',
          }}
        >
          <div 
            style={{
              width: '100%',
              height: '100%',
              background: 'linear-gradient(90deg, #7154b0, #8b6fd8)',
              borderRadius: '2px',
              animation: 'progressAnimation 2s ease-in-out infinite',
            }}
          />
        </div>
        {/* Progress Text */}
        <div 
          aria-hidden="true" 
          style={{
            marginTop: '12px',
            fontFamily: "'Outfit', sans-serif",
            fontSize: '14px',
            color: '#666',
            fontWeight: 500,
          }}
        >
          Personalizing your experience
        </div>
      </div>
      <style>{`
        @keyframes progressAnimation {
          0% { width: 0%; }
          50% { width: 70%; }
          100% { width: 100%; }
        }
      `}</style>
    </div>
  )
}

export const SplashScreen = () => {
  return (
    <SplashScreenBackground>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
        <CenteredLogo 
          src={APP_CONSTANTS.APP_LOGO_LINK} 
          onError={(e) => {
            e.target.src = '/logo_brand.png'
          }}
        />
      </div>
    </SplashScreenBackground>
  )
}

export const EmptyLoadingScreen = () => {
  return <LoadingSpinner />
}
